import React from 'react'
import NextImage from 'next/image'

import { Text } from '@wartek-id/text-v1'

interface ITitleSectionProps {
  title: string
  description: string
  thumbnail: string
}
const TitleSection: React.FC<ITitleSectionProps> = ({
  title,
  description,
  thumbnail,
}) => {
  return (
    <div className="flex justify-between space-x-3 p-4 bg-white">
      <div className="space-y-2">
        <div>
          <Text variant="heading-lg">{title}</Text>
        </div>
        <div>
          <Text variant="helper" color="subdued">
            {description}
          </Text>
        </div>
      </div>
      <div className="flex-none">
        <NextImage
          src={thumbnail}
          alt={`${title} thumbnail`}
          width="84"
          height="84"
        />
      </div>
    </div>
  )
}

export default TitleSection
